<template>
  <div class="about-menu">
    <router-link class="plain" to="/help">{{ $t('menuHelp') }}</router-link>
    <router-link class="plain" to="/contact">{{ $t('menuContact') }}</router-link>
    <router-link class="plain" to="/privacy">{{ $t('menuPrivacy') }}</router-link>
    <router-link class="plain" to="/cookies">{{ $t('menuCookies') }}</router-link>
    <router-link class="plain" to="/terms">{{ $t('menuTerms') }}</router-link>
  </div>
</template>

<script>
  export default {
    name: 'AboutMenu'
  }
</script>

<style lang="scss">
  .router-link-active {
    text-decoration: none;
    font-weight: bold;
  }
</style>

<style lang="scss" scoped>
  @import 'element-theme-chalk/src/mixins/mixins.scss';

  .about-menu {
    margin-top: 10px;
  }

  .about-menu a {
    margin: 10px 20px 10px 0;
    display: block;

    @include res(md) {
      display: inline;
    }
  }
</style>
